import { FieldArray, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FileUploader, FileUploaderResponse, FormikNotesArea, FormikTextInput } from "../../../../../../components/widgets"

import { KTSVG } from "../../../../../../../_metronic/helpers"


export const initDLMQuotationUploadValues = {
  quotations: [],
  note: '',  
  noteAttachments: [],
}

export const DLMQuotationUploadSchema: any = Yup.object({
  quotations: Yup.array().of(
    Yup.object().shape({
      quotationAttachmentId: Yup.number().integer().moreThan(0, 'Attachmemt ID required').required().label('Attachment ID'),
      quotationAttachmentName: Yup.string().trim(),
      quotationNumber: Yup.string().trim().required('Quotation Number required'),
    })
  ).min(1, 'Add quotations to upload').required().label('Quotations'),      
  note: Yup.string().trim().label('Note'),
  noteAttachments: Yup.array(),
});

export const DLMQuotationUploadForm = () => {

    const { values, setFieldValue, validateField } = useFormikContext();
    
    return (
    <>    
    <FieldArray
      name="quotations"
      render={({push, remove}) => (
        <>
        <div className="row mb-6">                               
          <FileUploader                             
            mainTitle="Quotation(s)"
            subTitle="Click or drop here to upload files."
            allowMultiple={false}
            acceptFiles="UserFileFormats"
            onFileUploaded={ (dat: FileUploaderResponse) => {
              push({
                quotationAttachmentId: dat.id,
                quotationAttachmentName: dat.name,
                quotationNumber: ''
              });                                                        
            }}                        
            onClearFile={ () => {
              setFieldValue("quotations", [], false);                            
              setTimeout(() => validateField("quotations"), 100)
            }}                        
          />               
        </div>
        <div className="row mb-4">
        <div className="table-responsive">                         
          <table                        
            className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer'                
          >
            <thead>
              <tr>
                <th>Quotation</th>
                <th className="required">Quotation Number</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            { //@ts-ignore
            values.quotations.map( (elem: any, idx: number) => (
            <tr key={`quoterow${idx}`}>
              <td>
                <span className="fs-7 fw-bold">{`${elem.quotationAttachmentName}`}</span>
              </td>
              <td>
                <FormikTextInput size="12" name={`quotations.${idx}.quotationNumber`} required />          
              </td>
              <td>
                <div 
                  className="rounded bg-light-danger bg-hover-danger text-center" 
                  onClick={ () => remove(idx)}
                  title="remove"
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr088.svg' className='svg-icon-1' />
                </div>                
              </td>
            </tr>
            ))}
            </tbody>
          </table>                        
        </div>
      </div>
      </>
    )}
    />
    <FormikNotesArea />        
    </>
    )
}